import "./EmergencyRestorationGuide.module.css";
import Header from "@/reusable_sections/Header";
import EmergencyGuide from "./sections/EmergencyGuide";
import Guidance from "./sections/Guidance";
import Dispatch from "./sections/Dispatch";
import Footer from "@/reusable_sections/Footer";
export default function EmergencyRestorationGuidePage() {
  return <div>
      <Header />
      <EmergencyGuide />
      <Guidance />
      <Dispatch />
      <Footer />
    </div>;
}